<script>
  import { onMount, onDestroy } from "svelte";
  import { l } from "$lib/Utils/l10n.svelte";
  import title from "$lib/App/title-store";
  import user from "$lib/App/user-store";
  import { action, actions } from "$lib/App/actions-store";
  import { goto } from "$app/navigation";
  import ActionGrid from "$lib/UI/Action/ActionGrid.svelte";
  import ActionTile from "$lib/UI/Action/ActionTile.svelte";
  import toasts from "$lib/UI/toast-store";
  import { call } from "$lib/Api/Api.svelte";
  import reason from "$lib/App/reason-store";
  import MessageStrip from "$lib/UI/MessageStrip.svelte";
  import infoContext from "$lib/App/info-context-store";
  import Block from "../../../lib/UI/Dialog/Block.svelte";
  import QRCode from "$lib/App/QRCode.svelte";
  import { invalidateAll } from "$app/navigation";

  let signinActions = [];
  let progressMessage = undefined;
  let url = undefined;
  let showQRCode = false;
  let sessionId;
  let qrState = "clear";

  onMount(() => {
    // authenticate();
    title.set(l("Aanmelden"));
    infoContext.set("signin");
    call("sessions", "create")
      .then((detachedSession) => {
        sessionId = detachedSession.sessionId;
        if (!!detachedSession.link) {
          url = detachedSession.link;
          showQRCode = true;
          doOpenQRSession();
        }
      })
      .catch(() => {
        progressMessage = undefined;
        toasts.push("Sessie aanvraag mislukt");
      });
  });

  function blurQRCode() {
    qrState = "blur";
  }

  const actionUnsubscribe = action.subscribe((a) => {
    doAct(a);
  });

  function doOpenSession() {
    if (!!sessionId) {
      call("sessions", "open", null, null, { sessionid: sessionId })
        .then((claims) => {
          user.set({
            ...$user,
            ...claims,
            authenticated: true,
          });
          progressMessage = undefined;
          toasts.push("Login geslaagd");
          window.location.href = "/";
        })
        .catch(() => {
          progressMessage = undefined;
          toasts.push("Login mislukt");
        });
    }
  }

  function doOpenQRSession() {
    if (!!sessionId) {
      call("sessions", "qropen", null, null, { sessionid: sessionId })
        .then((claims) => {
          user.set({
            ...$user,
            ...claims,
            authenticated: true,
          });
          progressMessage = undefined;
          toasts.push("Login geslaagd");
          window.location.href = "/";
        })
        .catch(() => {
          progressMessage = undefined;
          blurQRCode();
        });
    }
  }

  function doAct(a) {
    switch (a.action) {
      case "logout":
        action.clear();
        call("sessions", "close");
        sessionId = undefined;

        break;

      case "login":
        action.clear();
        reason.clear();
        progressMessage = "Nieuwe sessie aanvragen ...";
        call("sessions", "create")
          .then((detachedSession) => {
            sessionId = detachedSession.sessionId;
            if (!!detachedSession.nonce) {
              progressMessage = "Start login proces ...";
              blurQRCode();
              window.open(
                "ZorgID://s?n=" +
                  detachedSession.nonce +
                  "&e=" +
                  detachedSession.environment,
              );
              window.setTimeout(doOpenSession, 0);
            }
          })
          .catch(() => {
            progressMessage = undefined;
            toasts.push("Sessie aanvraag mislukt");
          });
        break;
      case "back":
      case "home":
        action.clear();
        goto("/");
        break;
    }
  }

  function doSelect(event) {
    doAct(event.detail);
  }

  onDestroy(() => {
    if (unsubscribe) {
      unsubscribe();
    }
    if (actionUnsubscribe) {
      actionUnsubscribe();
    }
  });

  const unsubscribe = user.subscribe((u) => {
    let act = [];
    if (u.authenticated === false) {
      act.push({
        id: "login",
        icon: "arrow-right-to-bracket",
        title: l("Aanmelden"),
        styleClass: "action-highlight",
        action: "login",
        rowtitle:
          "Klik op aanmelden voor inloggen met UZI-pas of ZORG-ID Smartcard",
        elucidation: "Aanmelden met ZORG-ID Desktop App",
      });
    } else {
      act.push({
        id: "consultation-back",
        icon: "chevron-left",
        title: "terug",
        styleClass: "action-highlight",
        action: "back",
        elucidation: l("Keer terug naar het startscherm."),
      });
      act.push({
        id: "logout",
        icon: "arrow-right-from-bracket",
        title: "afmelden",
        styleClass: "action-highlight",
        action: "logout",
        elucidation: l("Meld u af"),
      });
    }
    signinActions = act;
    actions.set(signinActions);
  });

  function doReset() {
    invalidateAll();
  }
</script>

{#if $user.authenticated === false}
  <div class="background">
    <div class="text-header">{l("U bent niet aangemeld.")}</div>
  </div>
{:else}
  <div>
    <div class="text-header">
      {l("U bent aangemeld als gebruiker")}
    </div>
    <div class="text-block">
      <p>
        {l("Meld u af of keer terug naar het startscherm.")}
      </p>
    </div>
  </div>
{/if}
{#if showQRCode}
  <ActionGrid>
    <div class="selection-row">
      <span class="row-title"
        >{l(
          "Scan de QR-code met de ZORG-ID Mobile App om aan te melden*",
        )}</span
      >
      <QRCode value={url} {qrState} on:click={doReset} />
    </div>
  </ActionGrid>
  <ActionGrid>
    <div class="or"><span>{l("of")}</span></div>
  </ActionGrid>
{/if}
<ActionGrid>
  {#each signinActions as action (action.id)}
    <div class="selection-row">
      <span class="row-title">
        {action.rowtitle}
      </span>
      <ActionTile {...action} on:select={doSelect} />
    </div>
  {/each}
</ActionGrid>

{#if $reason}
  <MessageStrip on:close={() => reason.clear()}>{$reason}</MessageStrip>
{/if}
{#if !!progressMessage}
  <Block message={progressMessage} />
{/if}
<!--
<div class="text-block">
  <a href="#" on:click={() => doAct({ action: "login-old" })}>Aanmelden</a> met oude
  versie desktop app.
</div>
-->

<div class="text-header">De zorg veilig en snel digitaal bereikbaar</div>
<!-- <p>
  ZORG-AB voorziet in de sterke behoefte aan één betrouwbare en actuele bron met
  alle gedetailleerde (digitale) adresgegevens van zorgaanbieders en
  zorgverleners in Nederland. ZORG-AB bevat naast de noodzakelijke
  contactinformatie ook allerlei technische informatie om computers en
  applicaties met elkaar te kunnen verbinden.
</p> -->
<p>
  * Nog geen ZORG-ID Mobile account? Vraag het <a
    href="https://www.formdesk.com/vzvz/Aanvraagformulier_ZORG-AB_Webportaal_inloggen_ZORG-ID_Mobiel"
    target="_blank">hier</a
  > aan, kies bij Softwareleverancier voor VZVZ – ZORG-AB Webportaal.
</p>

<style>
  .text-header {
    color: var(--theme-color);
    font-size: larger;
    text-align: center;
    margin: 1rem;
  }

  .text-block {
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .selection-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--accent-color);
    border-radius: 15px;
    margin: 1rem;
    padding: 1rem;
    min-width: 100%;
    border: 1px solid var(--accent-color);
  }

  .or {
    width: 30%;
    text-align: center;
    /* border-bottom: 1px solid #000;
    line-height: 0.1em; */
    margin: 3rem 0 3rem;
  }

  .or span {
    background: #fff;
    padding: 0 10px;
  }

  .row-title {
    padding: 4rem;
    font-size: larger;
  }

  @media screen and (max-height: 900px) {
    .or {
      width: 30%;
      text-align: center;
      /* border-bottom: 1px solid #000;
    line-height: 0.1em; */
      margin: 0;
    }
  }
</style>
